module.exports = "/matchcenter-staging/assets/images/matchcenter_search_clear.4347624e67bc3d9a7a6af6e502b46389.svg";